import { nameof as _nameof } from '@schibsted-nmp/advertising-shared';

export namespace RelevantDigital {
  export const nameof = _nameof.prefix({ RelevantDigital });
}
